export default {
  en: {
    title: 'Thank you for contacting us',
    instruction: 'Send us any comment, question or suggestion. We are here to help.',
    name: 'First Name',
    surnames: 'Last Name',
    postalcode: 'Zip Code',
    email: 'Email address',
    question: 'Question / Comment',
    question_label: 'Write here your question',
    subject: 'My question / comment is related to',
    send: 'Send',
    subjects: [
      {
        name: 'Select an option',
        value: ''
      },
      {
        name: 'Tickets',
        value: 'Tickets'
      },
      {
        name: 'Requirements to use CBX',
        value: 'Requirements to use CBX'
      },
      {
        name: 'Services',
        value: 'Services'
      },
      {
        name: 'Promos',
        value: 'Promos'
      },
      {
        name: 'Jobs at CBX',
        value: 'Jobs at CBX'
      },
      {
        name: 'Advertising & sales',
        value: 'Advertising & sales'
      },
      {
        name: 'I want to become a vendor',
        value: 'I want to become a vendor'
      },
      {
        name: 'Others',
        value: 'Others'
      }
    ]
  },
  es: {
    title: 'Gracias por contactarnos',
    instruction: 'Envíanos tu comentario, duda o sugerencia. Estamos para servirte.',
    name: 'Nombre',
    surnames: 'Apellidos',
    postalcode: 'Código Postal',
    email: 'Correo electrónico',
    question: 'Pregunta',
    question_label: 'Escribe aquí tu pregunta',
    subject: 'Mi asunto está relacionado con',
    send: 'Enviar',
    subjects: [
      {
        name: 'Selecciona una opción',
        value: ''
      },
      {
        name: 'Boletos',
        value: 'Boletos'
      },
      {
        name: 'Requerimientos de cruce',
        value: 'Requerimientos de cruce'
      },
      {
        name: 'Servicios que ofrece CBX',
        value: 'Servicios que ofrece CBX'
      },
      {
        name: 'Promociones',
        value: 'Promociones'
      },
      {
        name: 'Empleos en CBX',
        value: 'Empleos en CBX'
      },
      {
        name: 'Publicidad y ventas',
        value: 'Publicidad y ventas'
      },
      {
        name: 'Conviértete en socio comercial',
        value: 'Conviértete en socio comercial'
      },
      {
        name: 'Otro',
        value: 'Otro'
      }
    ]
  }
};
